<template>
  <a class="tt-pro" :href="`${provider.thumbtack_url}&utm_medium=partnership&utm_campaign=${glb.utm_campaign || 'search'}${utmParam ? '&'+utmParam : ''}&rf=true`" target="_blank">
    <div class="tt-pro__logo">
      <img loading="lazy" :src="provider.image_url" />
    </div>
    <div class="tt-pro__body">
      <div class="tt-pro__body-top">
        <div class="tt-pro__logo--mobile">
          <img :src="provider.image_url" />
        </div>
        <div class="tt-pro__details">
          <div class="tt-pro__name">
            <b>{{ provider.business_name }}</b>
          </div>
          <div v-if="provider.num_reviews">
            <span class="tt-pro__rating">
              {{ ratingDescription }} {{ formattedRating }} {{ " " }}
            </span>{{ " " }}
            <ThumbtackRating :rating="provider.rating" />
            <span class="tt-pro__review-count">({{ provider.num_reviews }})</span>
          </div>
          <div v-if="!provider.num_reviews">
            <span class="tt-pro__rating">No reviews yet</span>
          </div>
          <div v-if="provider.pills && provider.pills.length > 0" class="tt-pro__pills">
            <span
                v-for="pill in provider.pills"
                :class="['tt-pro__pill', `tt-pro__pill--${pillConfig[pill].theme}`]"
            >
              <i :class="[`icon-${pillConfig[pill].icon}`]"></i>
              <span>{{ pillConfig[pill].text }}</span>
            </span>
          </div>
          <div v-if="provider.num_hires">
            <i class="icon-map-pin-home"></i> {{ provider.num_hires }} similar jobs near you
          </div>
        </div>
        <div class="tt-pro__view-button">
          <div>
            <Button type="button" tabIndex={-1}>
                Get Quote
            </Button>
          </div>
          <div v-if="quote" class="tt-pro__estimated-cost">
            <b>{{ quote }}</b> <span>estimated cost</span>
          </div>
        </div>
      </div>
      <div class="tt-pro__body-bottom">
        {{ truncate(provider.introduction, { length: 200 }) }} <span class="tt-pro__see-more">See more</span>
      </div>
      <div class="tt-pro__body-bottom--mobile">
        {{ truncate(provider.introduction, { length: 80 }) }} <span class="tt-pro__see-more">See more</span>
      </div>
    </div>
  </a>
</template>

<script src="./thumbtackpro.js"></script>

<style lang="scss">
@use './thumbtackpro.scss' as *;
</style>